import React, { useState, useEffect } from "react";

import {
  Text,
  StyleSheet,
  View,
  TouchableOpacity,
  LayoutAnimation,
  Platform,
} from "react-native";

import APP_CONFIG from "../../../../config/AppConfig";

import ImageComponent from "../../common/ImageComponent";
import Icons from "../../common/icons/index";
import Collapsible from "../../common/Collapsible/Collapsible";
import SelectedTag from "./SelectedTag";

export default function TagsList(props) {
  const {
    tags,
    initialNumToRender,
    onSelectTag = () => {},
    onRemoveTag = () => {},
    showEditOptions = () => {},
    hideCollapse = false,
    showRemove = false,
    isReadOnly = false,
    title,
  } = props;

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [tagsList, setTagsList] = useState([]);
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (
      hasMoreItems &&
      initialNumToRender &&
      tags.length > initialNumToRender
    ) {
      setTagsList(tags.slice(0, initialNumToRender));
      setHasMoreItems(true);
      setMessage(tags.length - initialNumToRender + " more");
    } else {
      setTagsList(tags);
      setHasMoreItems(false);
    }
  }, [tags]);

  const showMore = () => {
    setTagsList([...tags]);
    setHasMoreItems(false);
  };

  const toggleExpand = () => {
    if (hideCollapse) return;
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setIsCollapsed(!isCollapsed);
  };

  const onLongPress = (e, item) => {
    e.preventDefault();
    showEditOptions(item);
  };

  return (
    <View>
      <TouchableOpacity style={styles.sectionHeader} onPress={toggleExpand}>
        {title ? <Text style={styles.header}>{title}</Text> : null}
        {!hideCollapse ? (
          <Icons.Collapse
            style={styles.collapseIcon}
            isCollapsed={isCollapsed}
          />
        ) : null}
      </TouchableOpacity>

      <Collapsible isCollapsed={isCollapsed}>
        <View style={styles.listContainer}>
          {tagsList.map((tag, index) => (
            <View style={styles.chipContainer} key={index}>
              {!isReadOnly && tag.isSelected ? (
                <SelectedTag
                  tag={tag}
                  styles={styles}
                  showRemove={showRemove}
                  onRemoveTag={onRemoveTag}
                ></SelectedTag>
              ) : (
                <TouchableOpacity
                  style={styles.chip}
                  onPress={() => onSelectTag(tag)}
                  onLongPress={() => showEditOptions(tag)}
                >
                  {tag.icon ? (
                    <ImageComponent
                      styles={styles.chipLogo}
                      icon={tag.icon}
                      action={() => onSelectTag(tag)}
                    />
                  ) : null}
                  <Text
                    style={styles.chipText}
                    onContextMenu={(e) => onLongPress(e, tag)}
                  >
                    {tag.name}
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          ))}
        </View>
        {hasMoreItems ? (
          <View style={styles.moreWrapper}>
            <Icons.MoreItems showMore={showMore} message={message} />
          </View>
        ) : null}
      </Collapsible>
    </View>
  );
}

const styles = StyleSheet.create({
  sectionHeader: {
    marginBottom: 10,
  },
  header: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: "#2D3142",
    display: "flex",
    alignItems: "center",
    paddingLeft: 5,
  },
  listContainer: {
    backgroundColor: "#fff",
    position: "relative",
    width: "100%",
    height: "auto",
    margin: "auto",
    paddingHorizontal: 0,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    overflow: "hidden",
  },
  chipContainer: {
    height: 38,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 6,
    marginRight: 4,
  },
  chip: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "100%",
    width: "100%",
    backgroundColor: "#F4F6FA",
    borderColor: "#F4F6FA",
    borderWidth: 1,
    marginHorizontal: 4,
    paddingVertical: 7,
    paddingHorizontal: 10,
    borderRadius: 100,
  },
  chipText: {
    fontFamily: 'Montserrat',
    fontWeight: '600',
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: APP_CONFIG.DEFAULT_COLOR,
    marginLeft: 5,
  },
  chipLogo: {
    width: 15,
    height: 15,
  },
  logoContainer: {
    width: 30,
    height: 30,
    borderRadius: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: -5,
    backgroundColor: "#FFF",
  },
  moreWrapper: {
    paddingLeft: 15,
    marginTop: 10,
  },
  selectedChip: {
    backgroundColor: APP_CONFIG.DEFAULT_COLOR,
    borderColor: APP_CONFIG.DEFAULT_COLOR,
  },
  selectedChipText: {
    color: "#FFF",
  },
  removeButton: {
    width: 16,
    height: 16,
    borderRadius: 8,
    position: "absolute",
    right: 5,
    top: 11,
    zIndex: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
